import { graphql, useStaticQuery } from 'gatsby';

export const useWebchatConfig = () => {
  const { contentfulDataWebchat } = useStaticQuery(graphql`
    query contentfulDataWebchatQuery {
      contentfulDataWebchat(name: { eq: "Webchat config" }) {
        contentful_id
        serviceHours {
          internal {
            content
          }
        }
        cardCtaOnline
        cardCtaOffline
        webchatCtaOnline
        webchatCtaOffline
        webchatCtaBusy
        statusDescriptionOnline
        statusDescriptionOffline
        statusDescriptionBusy
        statusDescriptionBankHoliday
        statusDescriptionLoading
      }
    }
  `);
  return contentfulDataWebchat;
};
